var map = {
	"./Settings-2.svg": 1281,
	"./broker-check-logo-footer.png": 2685,
	"./dostapniobuki.png": 5911,
	"./icon-audit.png": 8173,
	"./icon-dashboard.png": 4248,
	"./icon-documentation.png": 1233,
	"./icon-inbox.png": 6335,
	"./icon-investment.png": 4562,
	"./icon-issuers.png": 2465,
	"./icon-offerings.png": 8039,
	"./icon-point-contact.png": 5791,
	"./icon-profile.png": 8090,
	"./icons8-exit-32.png": 2288,
	"./icons8-menu-filled-48.png": 2452,
	"./icons8-plus-math-26.png": 2370,
	"./icons8-settings-50.png": 8927,
	"./moiobuki.png": 4994
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3421;